import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';
import { showModalPageClass, hideModalPageClass, setTextInputLongitud, arrayObjectToValue, setDataForm} from '../../../functions';
import axios from 'axios';
import Moment from 'moment';
import ModalFile from '../../Partials/ModalFile';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
registerLocale("es", es);


export default class EventoEditar extends Component {

    state = {
        evento: {
            Id: 0,
            ImagenPortadaMovil: '',
            ImagenPortadaMovilData: '',
            ImagenPortada: '',
            ImagenPortadaData: '',
            SectorId: '0',
            Tipo: '',
            Activo: 0
        },
        fechaPublicacionSelected: null,
        fechaFinSelected: null,
        fechaInicioSelected: null,
        guardando: false,
        sectores: [],
        tiposEvento: [],
        lineasProducto: [],
        lineasProductoSelected: [],
        mercados: [],
        mercadosSelected: [],
        partidas: [],
        partidasSelected: [],
        productos: [],
        productosSelected: []
    }

    handleClickGuardar(e) {
        e.preventDefault();

        if(this.state.guardando == false){
            this.setState({ guardando: true });
            const me = this;
    
            const url = `${API_URL}EventoUX/Actualizar`;
            
            let evento = {...this.state.evento};
            
            setDataForm(evento);
            
            evento["FechaPublicacion"] = Moment(this.state.fechaPublicacionSelected).format();
            evento["FechaInicio"] = Moment(this.state.fechaInicioSelected).format();
            evento["FechaFin"] = Moment(this.state.fechaFinSelected).format();

            evento["SectorId"] = document.getElementById('SectorCodigo').value;
            evento["UsuarioEdicion"] = cookie.load('user').nUsuCodigo;
            evento["Orden"] = 1;
            evento["Activo"] = this.state.evento.Activo;
            evento["LineasProducto"] = this.state.lineasProductoSelected.map(item => ({ LineaProductoCodigo: item.value }));
            evento["Ubicaciones"] = this.state.mercadosSelected.map(item => ({ UbicacionCodigo: item.value }));
            evento["Partidas"] = this.state.partidasSelected.map(item => ({ PartidaId: item.value }));
            evento["FichasProducto"] = this.state.productosSelected.map(item => ({ ProductoCodigo: item.value }));
            
            axios.post(url, JSON.stringify(JSON.stringify(evento)),
            { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }).then((data)=> {
                
                me.setState({ guardando:false });
                
                if(data.data.result.status){
                    this.props.history.push({
                        pathname: '/evento'
                    });
                }
            }).catch((error)=> {
                toast.error('Error no controlado.');
                me.setState({ guardando:false });
            });
        }
    }

    handleClickCancel(e) {
        this.props.history.push({
            pathname: '/evento'
        });
    }

    getSectors(){
        axios.get(API_URL + 'SectorUX').then(response => response.data)
        .then((data) => {
            
            let sectores = [];

            data.result.forEach(option => {
                if(option.bActivo === true){
                    sectores.push({id: option.nSectorCodigo, nombre: option.sDescripcion, codigo: option.sCodigoPP});
                }
            });

            this.setState({
                sectores: sectores
            });
        });
    }

    getMercados(){
        axios.get(API_URL + 'LocationUX').then(response => response.data)
        .then((data) => {
            this.setState({
                mercados: data.result.map(option => ({value: option.nUbicacionCodigo, label: option.sPais }))
            });
        });
    }

    getPartidas(){
        axios.get(API_URL + 'ItemUX/0').then(response => response.data)
        .then((data) => {
            this.setState({
                partidas: data.result.map(option => ({value: option.part_id, label: option.part_Codigo }))
            });
        });
    }

    getProductos(){
        axios.get(`${API_URL}FichaProductoUX/ListarTodos`).then(response => response.data)
        .then((data) => {
            this.setState({
                productos: data.result.data.map(option => ({value: option.productoCodigo, label: option.nombreProducto }))
            });
        });
    }

    getTiposEvento(){
        axios.get(API_URL + 'ParametroUX/TiposEvento').then(response => response.data)
        .then((data) => {
            this.setState({
                tiposEvento: data.result.map(option => ({id: option, nombre: option }))
            });
        });
    }

    getEvento(){
        axios.get(`${API_URL}EventoUX/ObtenerPorId?id=${this.props.match.params.id}`).then(response => response.data)
        .then((data) => {
            let item = data.result.data;
            
            document.getElementById('Titulo').value = item.titulo;
            document.getElementById('Extracto').value = item.extracto;
            document.getElementById('Enlace').value = item.enlace;
            document.getElementById('ImagenPortadaMovil').value = item.imagenPortadaMovil;
            document.getElementById('ImagenPortada').value = item.imagenPortada;

            let evento = {... this.state.evento};
        
            evento["Id"] = item.id;
            evento["ImagenPortada"] = item.imagenPortada;
            evento["ImagenPortadaData"] = '';
            evento["ImagenPortadaMovil"] = item.imagenPortadaMovil;
            evento["ImagenPortadaMovilData"] = '';
            evento["SectorId"] = item.sectorId;
            evento["Tipo"] = item.tipo;
            evento["Activo"] = item.activo;
    
            this.setState({
                evento,
                fechaPublicacionSelected: Moment(item.fechaPublicacion).toDate(),
                fechaFinSelected: Moment(item.fechaFin).toDate(),
                fechaInicioSelected: Moment(item.fechaInicio).toDate()
            });

            this.onChangeSector(null);

            let me = this;

            let loadProducto = setInterval(function (){
                if(me.state.productos.length > 0){
                    clearInterval(loadProducto);

                    let productosSelected = [];
                    let productosIdEventoSelected = arrayObjectToValue(item.fichasProducto, "productoCodigo");

                    me.state.productos.forEach(item => {
                        
                        if(productosIdEventoSelected.includes(item.value)){
                            productosSelected.push(item);
                        }
                    });

                    me.setState({
                        productosSelected
                    });
                }
            }, 100);

            let loadPartidas = setInterval(function (){
                if(me.state.partidas.length > 0){
                    clearInterval(loadPartidas);

                    let partidasSelected = [];
                    let partidasIdEventoSelected = arrayObjectToValue(item.partidas, "partidaId");

                    me.state.partidas.forEach(item => {
                        if(partidasIdEventoSelected.includes(item.value)){
                            partidasSelected.push(item);
                        }
                    });

                    me.setState({
                        partidasSelected
                    });
                }
            }, 100);

            let loadMercados = setInterval(function (){
                if(me.state.mercados.length > 0){
                    clearInterval(loadMercados);

                    let mercadosSelected = [];
                    let mercadosIdEventoSelected = arrayObjectToValue(item.ubicaciones, "ubicacionCodigo");

                    me.state.mercados.forEach(item => {
                        if(mercadosIdEventoSelected.includes(item.value)){
                            mercadosSelected.push(item);
                        }
                    });

                    me.setState({
                        mercadosSelected
                    });
                }
            }, 100);

            let loadLineasProducto = setInterval(function (){
                if(me.state.lineasProducto.length > 0){
                    clearInterval(loadLineasProducto);

                    let lineasProductoSelected = [];
                    let lineasProductoIdEventoSelected = arrayObjectToValue(item.lineasProducto, "lineaProductoCodigo");

                    me.state.lineasProducto.forEach(item => {
                        if(lineasProductoIdEventoSelected.includes(item.value)){
                            lineasProductoSelected.push(item);
                        }
                    });

                    me.setState({
                        lineasProductoSelected
                    });
                }
            }, 100);
        });
    }

    componentDidMount(){
        this.getSectors();
        this.getTiposEvento();
        this.getMercados();
        this.getPartidas();
        this.getProductos();
        this.getEvento();

        this.setState({
            fechaPublicacionSelected: new Date(),
            fechaInicioSelected: new Date(),
            fechaFinSelected: new Date()
        })
        setTextInputLongitud(['Titulo', 'Enlace', 'Extracto']);
    }

    handleFechaPublicacion = (valor) => {
        this.setState({
            fechaPublicacionSelected: valor
        })
    }

    handleFechaInicio = (valor) => {
        this.setState({
            fechaInicioSelected: valor
        })
    }

    handleFechaFin = (valor) => {
        this.setState({
            fechaFinSelected: valor
        })
    }

    showModalFile = (clase = "") => {
        showModalPageClass(clase);
    }

    onSelectArchivo(fileName, fileData, fieldName, fieldNameData){
        let evento = {... this.state.evento};
        
        evento[fieldName] = fileName;
        evento[fieldNameData] = fileData;

        document.getElementById(fieldName).value = fileName;

        this.setState({
            evento
        });

        hideModalPageClass(`div${fieldName}Upload`);
    }

    onChangeSector = (event) => {
        let sectorSelectedCodigo = '';
        let sectorSelected = event == null ? this.state.evento.SectorId : event.target.value;
        
        this.state.sectores.forEach(sector => {
            if(sector.id.toString() === sectorSelected.toString()){
                sectorSelectedCodigo = sector.codigo;
            }
        });

        axios.get(API_URL + `MasterUX/${sectorSelectedCodigo}/0/8/1`).then(response => response.data)
        .then((data) => {
            let lineasProducto = data.result.map(item => ({ value: item.nTipCodigo, label: item.sTipNombre  }));
            let evento = {...this.state.evento};

            evento["SectorId"] = sectorSelected;
            
            this.setState({
                lineasProducto: lineasProducto,
                lineasProductoSelected: [],
                evento
            });
        });
    }

    onChangeLineasProducto(items){
        this.setState({ lineasProductoSelected: items });
    }

    onChangeMercados(items){
        this.setState({ mercadosSelected: items });
    }

    onChangePartidas(items){
        this.setState({ partidasSelected: items });
    }

    onChangeProductos(items){
        this.setState({ productosSelected: items });
    }

    onChangeTipo = (event) => {
        let evento = {...this.state.evento};

        evento["Tipo"] = event.target.value;

        this.setState({
            evento
        });
    }

    render() {
        return (
            <div className="">
               <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                        <a href="/">
                            / Panel de configuración general
                        </a>
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Editar Evento</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Editar Evento
                </div>
                <div className="div_Modulos_Noticias">
                    <div className="div_WrapperEditarPagina">
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Titulo" id='Titulo' maxLength={255} className="data-test data-form"/>
                            <span id="longitudTitulo"></span>
                        </div>
                        <div className="txtFile x-1">
                            <div className="textareaResumen">
                                <textarea placeholder="Descripción Breve" id="Extracto" maxLength="4000" style={{height:"100px"}} className="data-test data-form"/>
                                <span id="longitudExtracto"></span>
                            </div>
                        </div>
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Enlace" id='Enlace' maxLength={255} className="data-test data-form"/>
                            <span id="longitudEnlace"></span>
                        </div>
                        <div className="x-1 relative">
                            <span className="subirArchivo" onClick={() => this.showModalFile("divImagenPortadaUpload")}/>
                            <input type="text" placeholder="Imagen Portada" id="ImagenPortada" readOnly={true} />
                            <i className="info">* El archivo debe tener formato de imagen</i>
                            <br />
                        </div>
                        <div className="x-1 relative">
                            <span className="subirArchivo" onClick={() => this.showModalFile("divImagenPortadaMovilUpload")}/>
                            <input type="text" placeholder="Imagen Portada Móvil" id="ImagenPortadaMovil" readOnly={true} />
                            <i className="info">* El archivo debe tener formato de imagen</i>
                            <br />
                        </div>
                        <div className="txtFile x-1">
                            <select id='SectorCodigo' name="SectorCodigo" className="data-test" onChange={(e) => this.onChangeSector(e)} value={this.state.evento.SectorId}>
                                <option value="0">Seleccionar Sector</option>
                                {
                                    this.state.sectores.length > 0 ?
                                    this.state.sectores.map((sector) => (
                                        <option key={sector.id} value={sector.id}>{sector.nombre.toUpperCase()}</option>
                                    ))
                                    : null
                                }
                            </select>
                        </div>
                        <div className="txtFile x-1">
                            <Select
                                classNamePrefix="select"
                                placeholder="Líneas de Producto"
                                options={this.state.lineasProducto}
                                value={this.state.lineasProductoSelected}
                                onChange={items => this.onChangeLineasProducto(items)}
                                isMulti={true}
                                isSearchable={true} />
                        </div>
                        <div className="txtFile x-1">
                            <Select
                                classNamePrefix="select"
                                placeholder="Mercados"
                                options={this.state.mercados}
                                value={this.state.mercadosSelected}
                                onChange={items => this.onChangeMercados(items)}
                                isMulti={true}
                                isSearchable={true} />
                        </div>
                        <div className="txtFile x-1">
                            <Select
                                classNamePrefix="select"
                                placeholder="Partidas"
                                options={this.state.partidas}
                                value={this.state.partidasSelected}
                                onChange={items => this.onChangePartidas(items)}
                                isMulti={true}
                                isSearchable={true} />
                        </div>
                        <div className="txtFile x-1">
                            <Select
                                classNamePrefix="select"
                                placeholder="Productos"
                                options={this.state.productos}
                                value={this.state.productosSelected}
                                onChange={items => this.onChangeProductos(items)}
                                isMulti={true}
                                isSearchable={true} />
                        </div>
                        <div className="txtFile x-2">
                            <select id='Tipo' className="data-test data-form" value={this.state.evento.Tipo} onChange={this.onChangeTipo}>
                                <option value="0">Seleccionar Tipo</option>
                                {
                                    this.state.tiposEvento.length > 0 ?
                                    this.state.tiposEvento.map((tipoEvento) => (
                                        <option key={tipoEvento.id} value={tipoEvento.id}>{tipoEvento.nombre.toUpperCase()}</option>
                                    ))
                                    : null
                                }
                            </select>
                        </div>
                        <div className="txtFile x-2 relative">
                            <DatePicker
                                locale="es"
                                dateFormat={"dd/MM/yyyy"}
                                selected={this.state.fechaPublicacionSelected}
                                onChange={this.handleFechaPublicacion} />
                                <i className="info">* Fecha Publicación</i>
                        </div>
                        <div className="txtFile x-2 relative">
                            <DatePicker
                                locale="es"
                                dateFormat={"dd/MM/yyyy"}
                                selected={this.state.fechaInicioSelected}
                                onChange={this.handleFechaInicio}
                                 />
                                <i className="info">* Fecha Inicio</i>
                        </div>
                        <div className="txtFile x-2 relative">
                            <DatePicker
                                locale="es"
                                dateFormat={"dd/MM/yyyy"}
                                selected={this.state.fechaFinSelected}
                                onChange={this.handleFechaFin}
                                 />
                                 <i className="info">* Fecha Fin</i>
                        </div>
                    </div>
                    <div className="divContenedorBtn_Noticias">
                        <a href="#" className="btnActivo" onClick={(event) => this.handleClickGuardar(event)}>{this.state.guardando ? 'PROCESANDO...' : 'GUARDAR'}</a>
                        <a href="#" onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <ModalFile class={"divImagenPortadaUpload"} onSelect={(filename, data) => this.onSelectArchivo(filename, data, "ImagenPortada", "ImagenPortadaData")} tipo="image" />
                <ModalFile class={"divImagenPortadaMovilUpload"} onSelect={(filename, data) => this.onSelectArchivo(filename, data, "ImagenPortadaMovil", "ImagenPortadaMovilData")} tipo="image" />
            </div>
        )
    }
}